import React from 'react';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import Scenario from '../../../classes/scenarioElements/Scenario';

export default function UIButtons(props)
{
	let properties = {
		'ok button properties' : {
			type: 'group',
			default: false,
			title: 'Ok Button',
		},
		'ok button text': {
			type: 'text',
			default: props.okText ? props.okText : 'OK'
		},
		'ok button text color': {
			type: 'color',
			default: '#ffffff'
		},
		'ok button text alpha': {
			type: 'range',
			default: 80,
			step: 1,
		},
		'ok button background color': {
			type: 'color',
			default: '#000000'
		},
		'ok button background alpha': {
			type: 'range',
			default: 60,
			step: 1,
		},
		'ok button shadow color': {
			type: 'color',
			default: '#000000'
		},
		'ok button shadow alpha': {
			type: 'range',
			default: 80,
			step: 1,
		},
		'cancel button properties' : {
			type: 'group',
			default: false,
			title: 'Cancel Button',
		},
		'cancel button visible': {
			type: 'toggle',
			default: props.okOnly ? false : true
		},
		'cancel button text': {
			type: 'text',
			default: props.cancelText ? props.cancelText : 'Cancel'
		},
		'cancel button text color': {
			type: 'color',
			default: '#ffffff'
		},
		'cancel button text alpha': {
			type: 'range',
			default: 80,
			step: 1,
		},
		'cancel button background color': {
			type: 'color',
			default: '#000000'
		},
		'cancel button background alpha': {
			type: 'range',
			default: 60,
			step: 1,
		},
		'cancel button shadow color': {
			type: 'color',
			default: '#000000'
		},
		'cancel button shadow alpha': {
			type: 'range',
			default: 80,
			step: 1,
		},
		'cancel button link': {
			type: 'step'
		},
		'visible': {
			type: 'toggle',
			default: true
		}
	}

	if(props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Buttons'}
				subcomponent={types.BUTTONS}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible)
	{
		const simulation = props.context === 'simulation';
		const data = props.data;
		const okText = data['ok button text'].value;
		const okColor = data['ok button text color'].value + percentToHex(data['ok button text alpha'].value);
		const okBgColor = data['ok button background color'].value + percentToHex(data['ok button background alpha'].value);
		const okShadowColor = data['ok button shadow color'].value + percentToHex(data['ok button shadow alpha'].value);

		const cancelVisible = data['cancel button visible'].value;
		const cancelText = data['cancel button text'].value;
		const cancelColor = data['cancel button text color'].value + percentToHex(data['cancel button text alpha'].value);
		const cancelBgColor = data['cancel button background color'].value + percentToHex(data['cancel button background alpha'].value);
		const cancelShadowColor = data['cancel button shadow color'].value + percentToHex(data['cancel button shadow alpha'].value);

		const cancelLink = data['cancel button link'].value;

		if(data['visible'].value !== true) return null;

		return (
			<div className={["uiButtonsRow", props.template].join(' ')}
				style={{width:'80%', left:'10%'}}
				data-name={'ui-buttons-row-root'}
				data-central={cancelVisible ? "false" : "true"}
			>
				{
					!cancelVisible ? null :
						<div className={["uiButton", props.template].join(' ')}
							data-name={"ui-button-cancel"}
							style={{
								borderColor: cancelShadowColor,
								backgroundColor: cancelBgColor,
								fontSize: simulation ? 36 : (0.8 * props.scale) + "vw",
								color: cancelColor,
							}}
							onClick={(e) =>
							{
								if (cancelLink && Scenario.getStep(cancelLink))
								{
									Scenario.setCurrentStep(Scenario.getStep(cancelLink));
								}
							}}
						>
							{cancelText}
						</div>
				}
				<div className={["uiButton", props.template].join(' ')}
					data-name={"ui-button-confirm"}
					style={{
						borderColor: okShadowColor,
						backgroundColor: okBgColor,
						fontSize: simulation ? 36 : (0.8 * props.scale) + "vw",
						color: okColor,
					}}
					onClick={(e) =>
					{
						const nextStep = Scenario.currentStep().getNextStep();
						if (nextStep)
						{
							Scenario.setCurrentStep(nextStep);
						}
					}}
				>
					{okText}
				</div>
			</div>
		);
	}

	return null;
}